import React from 'react';
import Transition from '../components/Transition.js';


function Privacy() {
  return (
    <main className="privacy">

        <section className="privacy">

        <h1>Privacy Policy for Duiker Travel</h1>
        <p><strong>Effective Date:</strong> 14 May 2025</p>
        <p><strong>Company:</strong> Duiker Travel</p>
        <p><strong>Location:</strong> Lusaka, Zambia</p>
        <p><strong>Website:</strong> <a href="http://duikertravel.com">duikertravel.com</a></p>
        <p><strong>Contact:</strong> <a href="mailto:info@duikertravel.com">info@duikertravel.com</a></p>

        <h2>1. Introduction</h2>
        <p>Duiker Travel respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our website or services.</p>

        <h2>2. Information We Collect</h2>
        <p>We may collect:</p>
        <ul>
        <li><strong>Personal Information:</strong> Name, email, phone number, and payment details when you book travel services.</li>
        <li><strong>Usage Data:</strong> IP address, browser type, and pages visited on duikertravel.com.</li>
        <li><strong>Cookies:</strong> We use cookies to improve your browsing experience. You can disable them in your browser settings.</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>We use your data to:</p>
        <ul>
        <li>Process bookings and payments.</li>
        <li>Communicate travel updates and promotions.</li>
        <li>Improve our website and services.</li>
        <li>Comply with legal obligations in Zambia.</li>
        </ul>

        <h2>4. Data Sharing</h2>
        <p>We do not sell your data. We may share it with:</p>
        <ul>
        <li>Travel partners (e.g., airlines, hotels) to fulfill bookings.</li>
        <li>Legal authorities if required by Zambian law.</li>
        </ul>

        <h2>5. Data Security</h2>
        <p>We use encryption and secure servers to protect your data. However, no online system is 100% secure, and we cannot guarantee absolute security.</p>

        <h2>6. Your Rights</h2>
        <p>Under Zambian law, you can:</p>
        <ul>
        <li>Request access to your data.</li>
        <li>Ask for corrections or deletion.</li>
        <li>Opt out of marketing emails.</li>
        </ul>
        <p>Contact us at <a href="mailto:info@duikertravel.com">info@duikertravel.com</a> to exercise these rights.</p>

        <h2>7. Data Retention</h2>
        <p>We retain your data for 5 years after your last booking or as required by law, then securely delete it.</p>

        <h2>8. Changes to This Policy</h2>
        <p>We may update this policy. Changes will be posted on <a href="http://duikertravel.com">duikertravel.com</a> with the effective date.</p>

        <h2>9. Contact Us</h2>
        <p>For questions, email us at <a href="mailto:info@duikertravel.com">info@duikertravel.com</a> or write to us at:
        Duiker Travel, Lusaka, Zambia.</p>

        </section>

    </main>
  );
}

export default Transition(Privacy);